export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.ofellio.app";
// Placeholder until the iOS listing id is published.
export const APP_STORE_URL = "https://www.apple.com/app-store/";
